
<!-- <div class="mpm-header">
    <div class="flex-align-center">
          <button class="back-btn" *ngIf="contactMode == 'createWithSearch'" (click)="goBack()" aria-label="Back"><i class="fa-regular fa-arrow-left"></i></button>
      
        <h3>{{ title }}</h3>
    </div>
    <button class="x-btn" (click)="modalRef.hide()" aria-label="Close"><i class="fa-regular fa-xmark"></i></button>
</div>
<div class="mpm-body"  *ngIf="contactMode == 'create' || contactMode == 'createWithSearch'" [formGroup]="addContactForm">
    <div class="form-grid">
        <div class="row-form span-12">
            <label>Name</label>
            <input type="text" placeholder="Search" pInputText formControlName="name"/>
            <div class="p-error text-10" *ngIf=" addContactForm.controls['name'].touched && addContactForm.controls['name'].invalid ">
                <span *ngIf="addContactForm.controls['name']?.errors?.required" id="label_JobAdditionalFaultReqField" >{{translate?.general.validationFE.requiredField}}</span>
            </div>
        </div>

        <div class="row-form span-12">
            <label>Email</label>
            <input type="email" formControlName="email"  pInputText formControlName="email"/>
            <div class="p-error text-10" *ngIf=" addContactForm.controls['email'].touched && addContactForm.controls['email'].invalid ">
                <span *ngIf="addContactForm.controls['email']?.errors?.required" id="label_JobAdditionalFaultReqField" >{{translate?.general.validationFE.requiredField}}</span>
                <span *ngIf="addContactForm.controls['email']?.errors?.pattern" id="label_JobAdditionalFaultReqField" >{{translate?.general.validationFE.invalidEmail}}</span>
            </div>
        </div>

        <div class="row-form span-12">
            <label>Phone</label>
            <input type="text" formControlName="phone" pInputText/>
            <div class="p-error text-10" *ngIf=" addContactForm.controls['phone'].touched && addContactForm.controls['phone'].invalid ">
                <span *ngIf="addContactForm.controls['phone']?.errors?.required" id="label_JobAdditionalFaultReqField" >{{translate?.general.validationFE.requiredField}}</span>
                <span *ngIf="addContactForm.controls['phone']?.errors?.pattern" id="label_JobAdditionalFaultReqField" >{{translate?.general.validationFE.invalidPhone}}</span>
            </div>
        </div>
    </div>

    <div class="mpm-actions">
        <span class="spacer"></span>
        <button class="custella-btn-white" (click)="modalRef.hide()">{{translate?.general.buttons.cancel.singular}}</button>
        <p-button [label]="translate?.general.buttons.update.singular" type="button" (onClick)="updateContact()"></p-button>
    </div>
</div>

 <div class="mpm-body" *ngIf="contactMode == 'select'">
   <div class="form-grid">
        <div class="row-form span-12">
           
        </div>
    </div>

    <div class="mpm-actions">
         <p-button styleClass="dark-alt" label="Add contact" icon="fa-regular fa-plus" type="button" (onClick)="goCreate()"></p-button>
        <span class="spacer"></span>
        <button class="custella-btn-white">{{translate?.general.buttons.cancel.singular}}</button>
    </div>
</div>  -->





<!-- NEW UPDATED DIALOG -->
<div class="flx-modal" role="dialog" aria-modal="true">
    <!-- Header -->
    <div class="flx-modal__header">
        <div class="with-back">
            <button class="back-btn" *ngIf="contactMode == 'createWithSearch'" (click)="goBack()" aria-label="Back"><i class="fa-regular fa-arrow-left"></i></button>
            <h2>{{ title }}</h2>
        </div>


        <button class="icon-btn" aria-label="Close" (click)="modalRef.hide()">
            <i class="fa-regular fa-xmark"></i>
        </button>
    </div>

    <!-- Body: FOR CHOOSING CONTACT -->
    <div class="flx-modal__body" *ngIf="contactMode === 'select'">
       <div class="field-row field-row--single">
             <!-- <p-dropdown placeholder="Select a contact..."
                [options]="contactData"
                optionLabel="contactPersonName"
                (onChange)="selectContact($event)"></p-dropdown> -->

            <p-dropdown 
                [options]="contactData" 
                [group]="true" 
                optionLabel="contactPersonName" 
                optionGroupLabel="valueName" 
                optionGroupChildren="modelFieldList" 
                placeholder="Select a contact..." 
                [filter]="true" 
                filterBy="contactPersonName"
                (onChange)="selectContact($event)">
                <ng-template let-group pTemplate="group">
                    {{ group.valueName }}
                </ng-template>
                <ng-template let-item pTemplate="item">
                    {{ item.contactPersonName }}
                </ng-template>
            </p-dropdown>

        </div>
    </div>
    <!-- Footer with Add Address -->
        <div class="flx-modal__footer-between" *ngIf="contactMode === 'select'">
            <div class="apply" >
                <p-button styleClass="dark-alt" label="{{translate?.general.buttons.add.singular}} {{translate?.contacts.label.singular}}" icon="fa-regular fa-plus" type="button" (onClick)="goCreate()"></p-button>
            </div>
            <div class="triggers">
                <button class="custella-btn-white" (click)="modalRef.hide()">{{translate?.general.buttons.cancel.singular}}</button>
            </div>
        </div>

    <!-- Body: FOR ADDING LOCATION -->
    <form [formGroup]="addContactForm" *ngIf="contactMode == 'create' || contactMode == 'createWithSearch'">
        <div class="flx-modal__body lean gap-10">
            <!-- Name -->
            <div class="status-field">
                <label class="field-label">{{translate?.contacts.fields.name.singular}}</label>
                <div class="field-row field-row--single gap-no">
                    <input type="text" placeholder="Enter {{translate?.contacts.label.singular}} {{translate?.contacts.fields.name.singular | lowercase}}..." pInputText formControlName="name"/>
                    <div class="p-error text-10" *ngIf=" addContactForm.controls['name'].touched && addContactForm.controls['name'].invalid ">
                        <span *ngIf="addContactForm.controls['name']?.errors?.required" id="label_JobAdditionalFaultReqField" >{{translate?.general.validationFE.requiredField}}</span>
                    </div>
                </div>
            </div>

            <!-- Email -->
            <div class="status-field">
                <label class="field-label">{{translate?.contacts.fields.email.singular}}</label>
                <div class="field-row field-row--single gap-no">
                    <input type="email" formControlName="email" placeholder="Enter {{translate?.contacts.label.singular}} {{translate?.contacts.fields.email.singular | lowercase}}..." pInputText/>
                    <div class="p-error text-10" *ngIf=" addContactForm.controls['email'].touched && addContactForm.controls['email'].invalid ">
                        <span *ngIf="addContactForm.controls['email']?.errors?.required" id="label_JobAdditionalFaultReqField" >{{translate?.general.validationFE.requiredField}}</span>
                        <span *ngIf="addContactForm.controls['email']?.errors?.pattern" id="label_JobAdditionalFaultReqField" >{{translate?.general.validationFE.invalidEmail}}</span>
                    </div>
                </div>
            </div>
            
             <!-- Phone -->
            <div class="status-field">
                <label class="field-label">{{translate?.contacts.fields.phone.singular}}</label>
                <div class="field-row field-row--single gap-no">
                    <input type="text" formControlName="phone" placeholder="Enter {{translate?.contacts.label.singular}} {{translate?.contacts.fields.phone.singular | lowercase}}..." pInputText/>
                    <div class="p-error text-10" *ngIf=" addContactForm.controls['phone'].touched && addContactForm.controls['phone'].invalid ">
                        <span *ngIf="addContactForm.controls['phone']?.errors?.required" id="label_JobAdditionalFaultReqField" >{{translate?.general.validationFE.requiredField}}</span>
                        <span *ngIf="addContactForm.controls['phone']?.errors?.pattern" id="label_JobAdditionalFaultReqField" >{{translate?.general?.validationFE.invalidPhoneNumber}}</span>
                    </div>
                </div>
            </div>
        </div>

        

        <!-- Footer without Add Address -->
        <div class="flx-modal__footer" *ngIf="contactMode == 'create' || contactMode == 'createWithSearch'">
            <button class="custella-btn-white" (click)="modalRef.hide()">{{translate?.general.buttons.cancel.singular}}</button>
            <p-button [label]="translate?.general.buttons.update.singular" styleClass="h-32" type="button" (onClick)="updateContact()"></p-button>
        </div>
    </form>
</div>